import type { EventResponse, EventsListResponse, MarketsQueryParams } from '@/types';
import axiosClient from './axiosClient';

import { API_ENDPOINTS } from '@/constants';

export const electionsApi = {
  /**
   * Fetch elections list
   * Uses the specific 'World Elections' tag ID (101206)
   */
  getElections: async (params?: Partial<MarketsQueryParams>): Promise<EventsListResponse> => {
    const defaultParams = {
      limit: 100,
      tag_id: '101206',
      active: true,
      closed: false,
      order: 'createdAt',
      ascending: true,
    };

    const response = await axiosClient.get<EventsListResponse>(API_ENDPOINTS.MARKETS_EVENTS_LIST, {
      params: { ...defaultParams, ...params },
    });

    return response.data;
  },
};
